import React, { useEffect, useMemo, useState } from 'react'
import { ContactContainer, TextContainer } from '@/styles/pages/contact'
import { useTranslation } from 'react-i18next'

import Public from '@/helpers/PageTypes/Public'

import SEO from '@/components/SEO'
import HeaderUnsigned from '@/components/LandingPage/Header'
import FooterUnsigned from '@/components/LandingPage/Footer'
import EmailButton from '@/components/EmailButton'
import { ContactForm } from '@/components/ContactForm'

import { ASSET_PATHS } from '@/services/paths'

import { ContactFormProvider } from '@/contexts/ContactFormContext'

const Contact = () => {
  const { t } = useTranslation()

  const [pageTitle, setPageTitle] = useState(' | Contact')
  const [subtitlesSales, setSubtitlesSales] = useState('')
  const [labelsContactWhats, setLabelsContactWhats] = useState('Whatsapp')

  const whatsAppLink = useMemo(
    () => `https://wa.me/${labelsContactWhats.replace(/\D/g, '')}`,
    [labelsContactWhats]
  )

  useEffect(() => {
    setPageTitle(` | ${t('titles.contact')}`)
    setSubtitlesSales(t('subtitles.sales'))
    setLabelsContactWhats(t('labels.contactWhats'))
  }, [t])

  return (
    <ContactFormProvider>
      <Public>
        <SEO title={pageTitle} />
        <HeaderUnsigned pageName="contact" />
        <ContactContainer>
          <TextContainer>
            <h1>{subtitlesSales}</h1>
            <a
              href={whatsAppLink}
              target="_blank"
              rel="noopener noreferrer"
              id="btn_whatsapp"
              className="flexbox v-centered"
            >
              <img
                src={ASSET_PATHS.icon_whatsapp}
                alt=""
                className="material-icons"
              />
              <span className="contact">{labelsContactWhats}</span>
            </a>
            <EmailButton id="contacts" iconOutline={false} />
          </TextContainer>
          <ContactForm />
        </ContactContainer>
        <FooterUnsigned />
      </Public>
    </ContactFormProvider>
  )
}

export default Contact
